import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/tokens.css'
import './styles/base.css'
import './styles/components.css'

import * as icons from '@/components/icons'

const app = createApp(App)
app.use(router)

// Register all icons globally so they work in any template
for (const [name, component] of Object.entries(icons)) {
  app.component(name, component)
}

// Wait for the router to resolve its initial navigation (including the
// auth-guard refresh) before mounting — otherwise App.vue renders the
// dashboard shell for one frame before the guard redirects to /login.
router.isReady().then(() => app.mount('#app'))
